/* unplugin-vue-components disabled */import { render } from "./NavigationBar.vue?vue&type=template&id=be12f948"
import script from "./NavigationBar.vue?vue&type=script&lang=js"
export * from "./NavigationBar.vue?vue&type=script&lang=js"

import "./NavigationBar.vue?vue&type=style&index=0&id=be12f948&lang=scss"

import exportComponent from "/data/repos/231_20260708141534/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__